export * from './useProductDetailsLocation';
